import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { ButtonSize } from "@/dashboard-design-system/DashboardButton/types";
import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { Reveal as Eye } from "@/icons/outlined";

export interface PreviewButtonProps {
  handlePreviewClick: () => void;
  isBlockSpaced?: boolean;
  size?: ButtonSize;
}

export const PreviewButton: FC<PreviewButtonProps> = ({ handlePreviewClick, isBlockSpaced, size }) => {
  const { t } = useTranslate();
  return (
    <DashboardButton
      vibe="neutral"
      variant="outlined"
      size={size}
      onClick={handlePreviewClick}
      sx={(theme) => ({
        marginLeft: theme.spacing(1),
        ...(isBlockSpaced && { marginBlock: theme.spacing(1) }),
      })}
      endIcon={
        <DashboardIcon size="small" vibe="inherit">
          <Eye />
        </DashboardIcon>
      }
    >
      {t("common", "preview")}
    </DashboardButton>
  );
};
